(function () {
  'use strict';

  angular.module('app').component('featuresPage', featureListComponent());

  function featureListComponent() {
    return {
      controller: FeatureListCtrl,
      controllerAs: 'vm',
      bindings: {},
      templateUrl: './app/ajs/admin/features/features-page.component.html',
    };
  }

  FeatureListCtrl.$inject = [
    'UtilService',
    'FeatureService',
    'FeatureCategoryService',
    'LanguageService',
  ];

  function FeatureListCtrl(UtilService, FeatureService, FeatureCategoryService, LanguageService) {
    var vm = this;

    var utils = new UtilService(vm);

    // Methods
    vm.onShowItem = onShowItem;

    // Initializers
    getItems('');
    getFeatureCategories();
    getAdditionalLanguages();

    function getItems(selectedItem) {
      vm.loadingItems = true;

      FeatureService.getFeatures().then(function (data) {
        vm.items = data.items;
        vm.meta = data.meta;

        vm.loadingItems = false;

        if (selectedItem) {
          utils.itemListChanged(selectedItem.id);
        }
      });
    }

    function getFeatureCategories() {
      FeatureCategoryService.getFeatureCategories({ get: 'active', skip_check_role: true }).then(
        function (data) {
          vm.featureCategories = data.items;
        }
      );
    }

    function getAdditionalLanguages() {
      LanguageService.getLanguages({ get: 'translations', skip_check_role: true }).then(function (
        data
      ) {
        vm.additionalLanguages = data.items;
      });
    }

    function onShowItem(item, mode) {
      FeatureService.openFeatureDetailModal(
        item,
        vm.additionalLanguages,
        mode,
        vm.featureCategories
      );
    }
  }
})();
